import member1 from '../assets/images/member1.jpg'
import member2 from '../assets/images/member2.jpg'
import member3 from '../assets/images/member3.jpg'
import mt2 from '../assets/images/mt2.jpg'
import mt3 from '../assets/images/mt3.jpg'
import mt4 from '../assets/images/mt4.jpg'
import mt5 from '../assets/images/mt5.jpg'
import mt6 from '../assets/images/mt6.jpg'
import mt7 from '../assets/images/mt7.jpg'
import mt8 from '../assets/images/mt8.jpg'
import mt9 from '../assets/images/mt9.jpg'
import mt10 from '../assets/images/mt10.JPG'
// import l1 from '../assets/images/l1.jpg'
import l2 from '../assets/images/l2.jpg'
import l3 from '../assets/images/l3.jpg'

const aboutUsData = {
  overview:
    "All the innovative and productive development today is based on people's intelligence, skills, and inner talents. The story from the developers of microsoft's, Apple's, Facebook's, etc, focused on us to know our inner talents to win over the world. As our educational system should play a vital role to enhance personal skills but it is based on theoretical knowledge more than practical due to this, Students are unable to show their existing skills and talent. To overcome this situation a potential platform must be needed to explore their talents. That's why TalentExploriz is established to get the larger intimacy of people towards the benefits of Extra-curricular activities which provide a Physical platform for students to explore their talent through different events and tournaments (like cricket, futsal, singing, dance, debate, Quiz, etc).",
  about:
    'Talent Exploriz aims to provide a Physical platform for students to explore their talent through Extra-Curricular activities(like cricket, futsal, singing, dance, debate, Quiz, etc) every Saturday, which helps them with financial, physical, and training support. It focuses on youths interested in Indoor and Outdoor activities like physical and mental events to show their inner talents in Infront of the world. It helps to connect with Students of different attitudes and knowledge for learning and bringing some positive attitude. Students can win cash prizes, coin incentives, and other attractive rewards, directly building their independency in their daily expenses. ',
  picture: [
    {
      title: 'Mission',
      description:
        'Provide educational and transformative experiences that expand knowledge, stimulate creativity, and encourage individuals to step out of their comfort zones.',
    },

    {
      title: 'Vision',
      description:
        'Larger intimacy of people towards the benefit of Extra-curricular activities to empower participants to discover new passions and reach their full potential.',
    },
    {
      title: 'Value Proposition',
      description:
        'Offering a user-friendly platform that allows easy registration, and participation in interesting events and tournaments with reasonable prices. ',
    },
  ],
  background:
    'We three partners from different fields of knowledge are Experimenting with running new innovative creations as our knowledge and experiences are matches this field. Our Experiment is about to start an Extracurricular platform for students which able to teach how competitive the real world is other than bookish knowledge. Talent Exploriz is a transformative platform that aims to revolutionize the way students engage in extra-curricular activities. By providing a physical space for participants to explore their talents in various fields such as sports, arts, and academics, Talent Exploriz creates an environment that nurtures personal growth and unleashes hidden potential. Through a combination of events, tournaments, and training support, Talent Exploriz empowers individuals to step out of their comfort zones, connect with like-minded peers, and develop valuable skills while enjoying the thrill of competition. With a strong emphasis on inclusivity, affordability, and creating a positive community, Talent Exploriz strives to make a lasting impact on the lives of students, fostering a lifelong love for learning and personal development.',

  problemSolution: [
    {
      problem:
        'Education System of schools/colleges more focused on theoretical knowledge',
      solution:
        'This platform supports students in continuing their extra-curricular activities for raising them physically, mentally, and financially strong. ',
    },
    {
      problem:
        'Students are addicted to engaging in online games and other unproductive social media. ',
      solution:
        'We create an alternative for them to reduce their addiction towards online games and other unproductive social media. ',
    },
    {
      problem:
        'Teenagers today are increasingly susceptible to mental health-related problems due to a lack of social environment.',
      solution:
        'Talent Exploriz becomes an opportunity for them to overcome social barriers, expand their network, and discover hidden talents, leading to enhanced self-confidence and a broader perspective on life.',
    },
    {
      problem:
        'There is a lack of adequate platforms for enthusiastic students to showcase their talents.',
      solution:
        'we provide them with a competitive Environment to make them financially, physically, and mentally fit.',
    },
  ],
  goals:
    'We aim to create a positive and inclusive environment where teenagers from all backgrounds can flourish. Our goal is to provide equal opportunities for learning and competition, reaching students across rural and urban areas throughout our country.',
  moreInfo:
    'Talent Exploriz is on a mission to empower 2500+ students each year by providing them with transformative extra-curricular experiences. Going beyond urban centers, we are dedicated to organizing events specifically tailored for students in rural areas, ensuring equal opportunities for talent exploration and personal growth. We also proudly collaborate with local organizations, joining forces for social causes that make a positive impact on our communities, fostering a sense of social responsibility among our participants. Together, we are creating a platform where students can thrive, connect, and contribute to a brighter future for all. ',

  mentors: [
    {
      name: 'Kamal Aryal',
      image: member1,
      description: [
        'Bachelor in Computer Engineering (Kantipur Engineering College, T.U.)',
        'Senior Developer (E-Signature Pvt. Ltd)',
      ],
    },
    {
      name: 'Rishi Ram Subedi',
      image: member2,
      description: [
        'Bachelor of computer science(University of the people)',
        'Master in Financial Engineering (WorldQuant University)',
        'Founder of Innovest Pvt. Ltd.',
      ],
    },
    {
      name: 'Aaditya Acharya',
      image: member3,
      description: [
        'BBA (Saraswati Multiple Campus, T.U.) ',
        'MA Economics (T.U.)',
        'Founder of Saraswati Foods Pvt. Ltd.',
      ],
    },
  ],
  managementTeams: [
    {
      name: 'Dipak Mahato',
      image: mt2,
      description: [
        'Shankar dev campus Representative',
        'Marketing and Promotions Specialist',
      ],
    },
    {
      name: 'Purusottam Prasad Shah',
      image: mt3,
      description: [
        'Saraswati Multiple Campus Representative',
        'Marketing and Promotions Specialist',
      ],
    },
    {
      name: 'Prakriti Chalise',
      image: mt4,
      description: [
        'Universal College Representative',
        'Event Management Specialist',
      ],
    },
    {
      name: 'Parbati Puri',
      image: mt5,
      description: [
        'Dillibazar Kanya Multiple Campus Represetative',
        'Event Management Specialist',
      ],
    },
    {
      name: 'Sushmi Rupakheti',
      image: mt6,
      description: [
        'Nepal College of Management Represenative (K.U)',
        'Event Management Specialist',
      ],
    },
    {
      name: 'Ranjana Khatri',
      image: mt7,
      description: [
        'Bhaktapur Multiple Campus Representative',
        'Medical and Safety Specialist',
      ],
    },
    {
      name: 'Sushan Lohla',
      image: mt8,
      description: [
        'Khwopa Higher Secondary School Representative',
        'Marketing and Promotions Specialist',
      ],
    },
    {
      name: 'Rajiv Yadav',
      image: mt9,
      description: [
        'Shankhar Dev Campus (Representative)',
        'Event Management Specialist',
      ],
    },
    {
      name: 'Adarsh Jayswal',
      image: mt10,
      description: [
        'Nepal Commerce Campus Representative',
        'Marketing and Promotional Specialist',
      ],
    },
  ],
  leadership: [
    // {
    //   name: 'Sundar Aryal',
    //   image: l1,
    //   description: [
    //     'Chief Executive Officer',
    //     'BBA(Saraswati Multiple Campus)',
    //   ],
    // },
    {
      name: 'Sumit Sunar',
      image: l2,
      description: [
        'Chief Technical Officer',
        'Bsc.HONS Computing (ISLINGTON College)',
        'Software Engineer (Innovate Tech)',
      ],
    },
    {
      name: 'Manita Subedi',
      image: l3,
      description: [
        'Chief Marketing Officer',
        'BBA(Saraswati Multiple Campus)',
      ],
    },
  ],
}

export default aboutUsData
